import { render, staticRenderFns } from "./ViewCustomerContainer.vue?vue&type=template&id=4d03c53a&scoped=true&"
import script from "./ViewCustomerContainer.vue?vue&type=script&lang=js&"
export * from "./ViewCustomerContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d03c53a",
  null
  
)

export default component.exports